import * as React from 'react';
import { useTheme } from '@emotion/react';
import { motion } from 'motion/react';
import { STORY_AUTOMATIONS, StoryScene } from '../story';
import { CloudCodeTask } from './CloudCodeTask';
import { S } from '../styles';

const CLOUD_WORKFLOW_PATH = 'M-30 427.5 H45';

interface CloudIntegrationsArtworkProps {
  scene: StoryScene;
  reducedMotion: boolean;
  animateConnections: boolean;
}

export const CloudIntegrationsArtwork: React.FC<CloudIntegrationsArtworkProps> = ({
  scene,
  reducedMotion,
  animateConnections
}) => {
  const theme = useTheme();
  const colors = theme.featureGraph;
  const transition = { duration: reducedMotion ? 0 : 0.7 };
  const visible = scene >= StoryScene.CLOUD_INTEGRATIONS;
  return (
    <>
      <motion.g initial={false} animate={{ opacity: visible ? 1 : 0 }} transition={transition}>
        <path d={CLOUD_WORKFLOW_PATH} fill="none" stroke={colors.cloudService.border} strokeWidth="2" />
        <S.Flow
          d={CLOUD_WORKFLOW_PATH}
          running={animateConnections}
          fill="none"
          stroke={colors.cloudService.accent}
          strokeWidth="2"
          strokeDasharray="5 22"
        />
        {STORY_AUTOMATIONS.map((job) => (
          <g key={job.title} transform={`translate(${job.x} ${job.y})`}>
            <CloudCodeTask title={job.title} source={job.source} result={job.result} running={animateConnections} />
          </g>
        ))}
      </motion.g>
    </>
  );
};
